






























































































































































































































import { MailMagazineManagementService as mailMagazineApi } from "@/common/api";
import { LANG } from "@/common/constant";
import QErrors from "@/common/qErrors.vue";
import QNotify from "@/common/qNotify";
import { compareWithKeys } from "@/common/utils";
import QEditor from "@/components/common/qEditor.vue";
import QLanguageBox from "@/components/common/qLanguageBox.vue";
import QLanguageTab from "@/components/common/qLanguageTab.vue";
import QReleaseSettingSendMail from "@/components/common/qReleaseSettingSendMail.vue";
import uploadFile from "@/components/common/uploadFile.vue";
import { TYPES, TYPES_NAME } from "@/model/mailMagazine";
import { SETTING, STATUS } from "@/model/releaseSetting";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "MagazinesEditComponent",
  components: {
    QErrors,
    QLanguageTab,
    QLanguageBox,
    QReleaseSettingSendMail,
    QEditor,
    uploadFile,
  },
})
export default class MagazinesEditComponent extends Vue {
  public title = "";
  public isShow = false;
  public mailMagazineId = null;

  public errors = {};
  public errorStyle = {
    maxWidth: "100%",
  };
  public initForm: any = {
    type: TYPES.ALL,
    title: "",
    title_en: null,
    title_cn: null,
    context: "",
    context_en: null,
    context_cn: null,
    plain_context: "",
    plain_context_en: null,
    plain_context_cn: null,
    open_status: STATUS.EDIT,
    release_setting: null,
    post_date: null,
  };

  public form: any = {};
  public originalForm;
  public files: any = [];
  public uploadOptions = {
    maxFilesize: 5, // 5mb
    acceptedFiles: ".xlsx, .docx, .pptx, .csv, .pdf, .jpeg, .jpg, .png",
  };
  public fileUploadStatus = "";
  public languages = [LANG.EN, LANG.CN];

  get types() {
    return TYPES_NAME;
  }

  public contextLang = LANG.JA;
  public uploading = false;

  get langList() {
    return [...[LANG.JA], ...this.languages];
  }

  public async show(mailMagazineId, isClone = false) {
    this.clearForm();
    this.isShow = true;
    this.title = "メールマガジンの作成";
    if (mailMagazineId) {
      this.mailMagazineId = mailMagazineId;
      await this.getDetail(isClone);
    }

    if (!this.form.title_cn && !this.form.context_cn) {
      const index = this.languages.indexOf(LANG.CN);
      this.languages.splice(index, 1);
    }
    this.originalForm = { ...this.form };

    this.$el.querySelector(".magazineEditContent").scrollTop = 0;
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }

  public removeFile(index) {
    (this.$refs.myVueDropzone as uploadFile).removeFile(
      this.files[index],
      index,
    );
  }

  public pushError(message) {
    this.errors = {
      ...this.errors,
      ...{ uploadFiles: message },
    };
  }
  public changeFile(files) {
    this.files = files.map((file) => {
      return file.id || !file.upload
        ? file
        : {
          id: null,
          extension: file.extension,
          name: file.filePath,
          originalName: file.upload.filename,
          container: "File",
          size: file.upload.bytesSent,
          mimeType: file.mimeType,
        };
    });
  }

  public uploadStatus(flag) {
    this.uploading = flag;
  }

  public async getDetail(isClone) {
    const result = await mailMagazineApi.adminMailMagazineShow({
      id: this.mailMagazineId,
    });

    if (isClone) {
      this.form.type = result.data.mailMagazine.type;
      this.form.title = result.data.mailMagazine.title;
      this.form.title_en = result.data.mailMagazine.title_en;
      this.form.title_cn = result.data.mailMagazine.title_cn;
      this.form.context = result.data.mailMagazine.context;
      this.form.context_en = result.data.mailMagazine.context_en;
      this.form.context_cn = result.data.mailMagazine.context_cn;
      this.mailMagazineId = null;
      this.files = result.data.mailMagazine.mail_magazine_files.map((item) => {
        item.file.id = null;

        return item.file;
      });
      this.title = result.data.mailMagazine.title + "の複製";
      return;
    }

    const mailMagazine = result.data.mailMagazine;
    this.form = mailMagazine;
    this.files = mailMagazine.mail_magazine_files.map((item) => item.file);
    this.title = mailMagazine.title + "の更新";

    if (
      this.form.open_status === STATUS.RELEASE &&
      moment(this.form.post_date).isBefore(moment())
    ) {
      this.form.release_setting = SETTING.NOW;
      this.form.post_date = null;
    }

    if (
      this.form.post_date &&
      this.form.open_status === STATUS.SEND &&
      this.form.release_setting !== SETTING.NOW
    ) {
      this.form.post_date = moment(this.form.post_date).format(
        "YYYY-MM-DD HH:mm",
      );
    } else {
      this.form.post_date = null;
    }
  }

  public async submit() {
    let parameters: any = {};
    let result;
    try {
      let files = [];
      const uploadFiles = this.files.filter((item) => !item.id);

      if (uploadFiles.length > 0) {
        result = await mailMagazineApi.adminMailMagazineFileUpload({
          list: uploadFiles,
        });

        files = result.data.files;
        this.files = [...this.files.filter((item) => item.id), ...files];
      }

      parameters = {
        type: this.form.type,
        title: this.form.title,
        title_en: this.languages.includes("en") ? this.form.title_en : null,
        title_cn: this.languages.includes("cn") ? this.form.title_cn : null,
        upload_files: this.files,
        context: this.form.context,
        context_en: this.languages.includes("en") ? this.form.context_en : null,
        context_cn: this.languages.includes("cn") ? this.form.context_cn : null,
        plain_context: this.form.plain_context,
        plain_context_en: this.languages.includes("en")
          ? this.form.plain_context_en
          : null,
        plain_context_cn: this.languages.includes("cn")
          ? this.form.plain_context_cn
          : null,
        tag_ids: this.form.tag_ids,
        open_status: this.form.open_status,
        release_setting: this.form.release_setting,
        post_date: this.form.post_date,
      };

      result = this.mailMagazineId
        ? await mailMagazineApi.adminMailMagazineEdit({
          ...parameters,
          ...{ id: this.mailMagazineId },
        })
        : await mailMagazineApi.adminMailMagazineCreate(parameters);

      QNotify.success({
        text: this.mailMagazineId
          ? this.$t("common.message.updated")
          : this.$t("common.message.created"),
      });
      this.closePopup();
    } catch (error: any) {
      result = error.body;
      QNotify.error({
        text: result.message,
      });
      this.errors = result.errors;
      if ("context" in this.errors) {
        this.contextLang = LANG.JA;
      } else if ("context_en" in this.errors) {
        this.contextLang = LANG.EN;
      } else if ("context_cn" in this.errors) {
        this.contextLang = LANG.CN;
      }
    }
  }

  public confirmTest() {
    this.$modal.showCancel({
      title: `${this.$t("mailmagazine_management.title.send_test_confirm")}`,
      text: `${this.$t("mailmagazine_management.message.send_test_confirm")}`,
      confirmText: `${this.$t("mailmagazine_management.button.confirm")}`,
      onConfirm: () => {
        this.submitTest();
      },
    });
  }

  public async submitTest() {
    let parameters: any = {};
    let result;
    try {
      let files = [];
      const uploadFiles = this.files.filter((item) => !item.id);

      if (uploadFiles.length > 0) {
        result = await mailMagazineApi.adminMailMagazineFileUpload({
          list: uploadFiles,
        });

        files = result.data.files;
        this.files = [...this.files.filter((item) => item.id), ...files];
      }

      parameters = {
        type: this.form.type,
        title: this.form.title,
        title_en: this.languages.includes("en") ? this.form.title_en : null,
        title_cn: this.languages.includes("cn") ? this.form.title_cn : null,
        upload_files: this.files,
        context: this.form.context,
        context_en: this.languages.includes("en") ? this.form.context_en : null,
        context_cn: this.languages.includes("cn") ? this.form.context_cn : null,
        plain_context: this.form.plain_context,
        plain_context_en: this.languages.includes("en")
          ? this.form.plain_context_en
          : null,
        plain_context_cn: this.languages.includes("cn")
          ? this.form.plain_context_cn
          : null,
        tag_ids: this.form.tag_ids,
        open_status: this.form.open_status,
        release_setting: this.form.release_setting,
        post_date: this.form.post_date,
        is_test: true,
      };

      result = this.mailMagazineId
        ? await mailMagazineApi.adminMailMagazineEdit({
          ...parameters,
          ...{ id: this.mailMagazineId },
        })
        : await mailMagazineApi.adminMailMagazineCreate(parameters);

      QNotify.success({
        text: this.mailMagazineId
          ? this.$t("common.message.updated")
          : this.$t("common.message.created"),
      });
      this.mailMagazineId = result.data.mailMagazine.id;
    } catch (error: any) {
      result = error.body;
      QNotify.error({
        text: result.message,
      });
      this.errors = result.errors;
      if ("context" in this.errors) {
        this.contextLang = LANG.JA;
      } else if ("context_en" in this.errors) {
        this.contextLang = LANG.EN;
      } else if ("context_cn" in this.errors) {
        this.contextLang = LANG.CN;
      }
    }
  }

  public confirmDelete() {
    this.$modal.showDelete({
      text: `${this.$t("common.message.delete_confirm")}`,
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        let message: any;
        try {
          const response = await mailMagazineApi.adminMailMagazineDelete({
            id: this.mailMagazineId,
          });

          message = response.message;
          QNotify.success({
            text: message,
          });
          this.isShow = false;
        } catch (error) {
          message = error.body.message;
          QNotify.error({
            text: message,
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public cancel() {
    // check modifier form.
    const diff = compareWithKeys(this.form, this.originalForm, [
      "title",
      "title_en",
      "title_cn",
      "context",
      "context_en",
      "context_cn",
      "plain_context",
      "plain_context_en",
      "plain_context_cn",
      "open_status",
      "post_date",
      "release_setting",
    ]);

    if (!diff) {
      this.$modal.showCancel({
        text: `${this.$t("common.message.cancel_confirm")}`,
        onConfirm: () => {
          this.isShow = false;
        },
      });
    } else {
      this.isShow = false;
    }
  }

  public closePopup() {
    this.clearForm();
    this.isShow = false;
    this.$emit("close");
  }

  public clearForm() {
    this.mailMagazineId = null;
    this.contextLang = LANG.JA;
    this.languages = [LANG.EN, LANG.CN];
    this.files = [];
    this.form = JSON.parse(JSON.stringify(this.initForm));
    this.errors = {};
  }
}
